export default "__VITE_ASSET__CfPYq7yk__"